Unit UserEdit;

Interface

Uses
  System.SysUtils,
  System.Classes,
  System.Generics.Collections,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  WebForm.Core,
  Data.DB,
  WEBLib.DB,
  Vcl.Controls,
  Vcl.StdCtrls,
  WEBLib.ExtCtrls,
  WEBLib.DBCtrls,
  WEBLib.StdCtrls,
  CSY.Enumerations,
  Sys.Return.Types;

Type
  TUserEditForm = Class(TCoreWebForm)
    UserDataSource: TDataSource;
    InternalIdLabel: TDBLabel;
    FirstNameEdit: TDBEdit;
    LastNameEdit: TDBEdit;
    TitleEdit: TDBEdit;
    PhoneNumberEdit: TDBEdit;
    EmailEdit: TDBEdit;
    UserScopeEdit: TDBLookupComboBox;
    UserStatusEdit: TDBLookupComboBox;
    UserEditCancelButton: TButton;
    UserEditSaveButton: TButton;
    UserEditMessage: TLabel;
    UserChange: TMessageDlg;
    BranchIdTypeEdit: TDBComboBox;
    BranchIdEdit: TDBLookupComboBox;
    BranchIdLabel: TLabel;
    PasswordPanel: TPanel;
    UserPassword: TDBEdit;
    PasswordErrorLabel: TLabel;
    PasswordHintLabel: TLabel;
    LoadListTimer: TTimer;
    procedure BranchIdTypeEditChange(Sender: TObject);
    Procedure WebFormDestroy(Sender: TObject);
    Procedure UserEditCancelButtonClick(Sender: TObject);
    [async]
    Procedure UserEditSaveButtonClick(Sender: TObject); async;
    Procedure WebFormCreate(Sender: TObject);
    procedure LoadListTimerTimer(Sender: TObject);
  Private
    FUser: TAppUser;
    FAvailableSeats: Integer;
    FNewUserPassword: String;
    FBranches: TList<TBranch>;
    FBranchGroups: TList<TBranchGroup>;
    FLastIdsLoaded: TBranchIdType;
    Function GetDataset: TDataset;
    Procedure SetDataset(Const Value: TDataset);
    Procedure LoadScope;
    Procedure LoadStatus;
    Procedure LoadIdType;
    [async]
    Procedure LoadBranchIdLookup; async;
    Procedure LoadBranchList;
    Procedure LoadBranchGroupList;
    Function ValidateFields: Boolean;
    Procedure DisplayUserMessage(Const Value: String);
    Procedure ClearPasswordValidationErrors;
    Function FormatPasswordErrorText(AErrors: TStrings): String;
    Procedure CollectPasswordValidationErrors(Const APassword: String; AErrors: TStrings);
    Procedure ShowPasswordValidationErrors(AErrors: TStrings);
    Procedure ShowPasswordValidationForValue(Const APassword: String);
    Function GetIsNewUser: Boolean;
    Function GetBranchIdType: TBranchIdType;
    Function IsPasswordValidationError(Const AMessage: String): Boolean;
    [async]
    Function SaveNewUser: Boolean; async;
    Procedure SyncBranchAssignmentToDataset;
    [async]
    Procedure LoadLists; async;
    [async]
    Procedure LoadBranches; async;
    [async]
    Procedure LoadBranchGroups; async;

    { Private declarations }
    Property IsNewUser: Boolean Read GetIsNewUser;
    Property BranchIdType: TBranchIdType Read GetBranchIdType;
  Public
    { Public declarations }
    Procedure ShowServerPasswordError;
    Property Dataset: TDataset Read GetDataset Write SetDataset;
    Property NewUserPassword: String Read FNewUserPassword;
  protected procedure LoadDFMValues; override; End;

Var
  UserEditForm: TUserEditForm;

Implementation

{$R *.dfm}

Uses
  XData.Web.Client,
  SMX.Auth.Shared,
  UserManager.Utils,
  SMX.Web.Document.Utils,
  MainDataModule, SMX.XData.Utils;

Const
  PASSWORD_MIN_LENGTH = 10;

procedure TUserEditForm.BranchIdTypeEditChange(Sender: TObject);
begin
 FUser.BranchId := '';
 LoadBranchIdLookup;
end;

Procedure TUserEditForm.WebFormDestroy(Sender: TObject);
Begin
  If Assigned(FUser) Then
    FUser.Free;
  if Assigned(FBranchGroups) then
     FBranchGroups.Free;
  if Assigned(FBranches) then
     FBranches.Free;
  Inherited;
End;

Procedure TUserEditForm.WebFormCreate(Sender: TObject);
Begin
  Inherited;
  LoadScope;
  LoadStatus;
  LoadIdType;
  ClearPasswordValidationErrors;
End;

{ TUserEditForm }

Procedure TUserEditForm.ClearPasswordValidationErrors;
Begin
  PasswordErrorLabel.Caption := '';
  PasswordErrorLabel.Visible := False;
  PasswordHintLabel.Visible := IsNewUser;
End;

Function TUserEditForm.FormatPasswordErrorText(AErrors: TStrings): String;
Var
  I: Integer;
Begin
  Result := '';
  For I := 0 To AErrors.Count - 1 Do
  Begin
    If Result <> '' Then
      Result := Result + sLineBreak;
    Result := Result + '- ' + AErrors[I];
  End;
End;

Procedure TUserEditForm.CollectPasswordValidationErrors(Const APassword: String; AErrors: TStrings);
Var
  I: Integer;
  lHasDigit, lHasUpper, lHasLower, lHasSymbol: Boolean;
  lCh: Char;
Begin
  AErrors.Clear;
  If Trim(APassword) = '' Then
  Begin
    AErrors.Add('A password is required for new users.');
    Exit;
  End;

  If Length(APassword) < PASSWORD_MIN_LENGTH Then
    AErrors.Add(Format('Passwords must be at least %d characters long.', [PASSWORD_MIN_LENGTH]));

  lHasDigit := False;
  lHasUpper := False;
  lHasLower := False;
  lHasSymbol := False;
  For I := 1 To Length(APassword) Do
  Begin
    lCh := APassword[I];
    If (lCh >= '0') And (lCh <= '9') Then
      lHasDigit := True
    Else If (lCh >= 'A') And (lCh <= 'Z') Then
      lHasUpper := True
    Else If (lCh >= 'a') And (lCh <= 'z') Then
      lHasLower := True
    Else
      lHasSymbol := True;
  End;

  If Not lHasDigit Then
    AErrors.Add('Passwords must have at least one digit (''0''-''9'').');
  If Not lHasUpper Then
    AErrors.Add('Passwords must have at least one uppercase character (''A''-''Z'').');
  If Not lHasLower Then
    AErrors.Add('Passwords must have at least one lowercase character (''a''-''z'').');
  If Not lHasSymbol Then
    AErrors.Add('Passwords must have at least one non letter or digit character.');
End;

Procedure TUserEditForm.DisplayUserMessage(Const Value: String);
Begin
  UserEditMessage.Caption := Value;
  UserEditMessage.Visible := (Value <> '');
End;

Function TUserEditForm.GetBranchIdType: TBranchIdType;
Begin
  Result := TBranchIdType(BranchIdTypeEdit.ItemIndex);
End;

Function TUserEditForm.GetDataset: TDataset;
Begin
  Result := UserDataSource.Dataset;
End;

Function TUserEditForm.GetIsNewUser: Boolean;
Begin
  Result := UserDataSource.State = TDataSetState.dsInsert;
End;

Procedure TUserEditForm.LoadBranchGroupList;
Const
  branchgroup_svc = 'IBranchService.GetSelectableBranchGroups';
Var
  I: Integer;
  lBranchGroup: TBranchGroup;
Begin
  BranchIdEdit.LookupValues.Clear;

  for lBranchGroup in FBranchGroups do
    BranchIdEdit.LookupValues.AddPair(lBranchGroup.Id, lBranchGroup.Name);

  BranchIdEdit.Value := FUser.BranchId;

  FLastIdsLoaded := TBranchIdType.BranchGroup;
  BranchIdLabel.Caption := 'Branch Group';
End;

Procedure TUserEditForm.LoadBranchIdLookup;
var lBranchIdType: TBranchIdType;
Begin

  lBranchIdType := BranchIdType;
  if lBranchIdType = FLastIdsLoaded then
     Exit;

  BranchIdEdit.LookupValues.BeginUpdate;

  Try

    Case lBranchIdType Of
      TBranchIdType.NotSpecified:
        Begin
          BranchIdEdit.LookupValues.Clear;
          FLastIdsLoaded := TBranchIdType.NotSpecified;
            BranchIdLabel.Caption := 'Branch Group/Branch';
        End;
      TBranchIdType.Branch:
        LoadBranchList;
      TBranchIdType.BranchGroup:
        LoadBranchGroupList;
    End;

  Finally
    BranchIdEdit.LookupValues.EndUpdate;
    BranchIdEdit.Enabled := BranchIdEdit.LookupValues.Count > 0;
  End;
End;

Procedure TUserEditForm.LoadBranchList;
Var
  I: Integer;
  lBranch: TBranch;
Begin
  BranchIdEdit.LookupValues.Clear;

  for lBranch in FBranches do
    BranchIdEdit.LookupValues.AddPair(lBranch.Id, lBranch.Name);

  BranchIdEdit.Value := FUser.BranchId;

  FLastIdsLoaded := TBranchIdType.Branch;
  BranchIdLabel.Caption := 'Branch';
End;

Procedure TUserEditForm.LoadIdType;
Begin
  BranchIdTypeEdit.Items.Add('All');
  BranchIdTypeEdit.Items.Add('Branch');
  BranchIdTypeEdit.Items.Add('BranchGroup');
End;

Procedure TUserEditForm.LoadScope;
Begin
  UserScopeEdit.LookupValues.AddPair(SCOPE_USER, 'Standard User');
  UserScopeEdit.LookupValues.AddPair(SCOPE_ADMIN, 'Administrator');
End;

Procedure TUserEditForm.LoadStatus;
Begin
  // TUserStatus has no Inactive — use Blocked for "inactive" users
  UserStatusEdit.LookupValues.AddPair('Pending', 'Pending');
  UserStatusEdit.LookupValues.AddPair('Blocked', 'Inactive');
  UserStatusEdit.LookupValues.AddPair('Active', 'Active');
  UserStatusEdit.LookupValues.AddPair('System', 'System');
End;

Procedure TUserEditForm.ShowPasswordValidationErrors(AErrors: TStrings);
Begin
  If (AErrors = Nil) Or (AErrors.Count = 0) Then
  Begin
    ClearPasswordValidationErrors;
    TDocUtils.setControlValidity('UserPassword', Valid_Check[True]);
    Exit;
  End;

  TDocUtils.setControlValidity('UserPassword', Valid_Check[False]);
  PasswordErrorLabel.Caption := FormatPasswordErrorText(AErrors);
  PasswordErrorLabel.Visible := True;
  PasswordHintLabel.Visible := False;
  DisplayUserMessage('');
  UserPassword.SetFocus;
End;

Procedure TUserEditForm.ShowPasswordValidationForValue(Const APassword: String);
Var
  lErrors: TStringList;
Begin
  lErrors := TStringList.Create;
  Try
    CollectPasswordValidationErrors(APassword, lErrors);
    ShowPasswordValidationErrors(lErrors);
  Finally
    lErrors.Free;
  End;
End;

Procedure TUserEditForm.ShowServerPasswordError;
Begin
  ShowPasswordValidationForValue(FNewUserPassword);
End;

Function TUserEditForm.IsPasswordValidationError(Const AMessage: String): Boolean;
Var
  lMsg: String;
Begin
  lMsg := LowerCase(AMessage);
  Result := (Pos('password', lMsg) > 0) And
    ((Pos('not valid', lMsg) > 0) Or (Pos('validation', lMsg) > 0) Or
     (Pos('required', lMsg) > 0));
End;

Function TUserEditForm.SaveNewUser: Boolean;
Const
  add_svc = 'IUserManagerService.AddUser';
Var
  AUser, AResponseUser: TAppUser;
  lRetval: TXDataClientResponse;
  lResponse: TJSObject;
Begin
  Result := False;
  SyncBranchAssignmentToDataset;
  AUser := TUserManagerUtils.DatasetToUser(Dataset);
  Try
    AUser.UserPassword := FNewUserPassword;
    Try
      lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(add_svc, [AUser, AUser.UserPassword]));
    Except
      On E: Exception Do
      Begin
        If IsPasswordValidationError(E.Message) Then
          ShowServerPasswordError
        Else
          DisplayUserMessage(E.Message);
        Exit;
      End;
    End;
    lResponse := lRetval.ResultAsObject;
    AResponseUser := TAppUser.Create;
    Try
      AResponseUser.Assign(lResponse);
      TUserManagerUtils.UserToDataset(AResponseUser, Dataset);
      Result := True;
    Finally
      AResponseUser.Free;
    End;
  Finally
    AUser.Free;
  End;
End;

Function TUserEditForm.ValidateFields: Boolean;
Var
  lValid, AllValid: Boolean;
  lPassword: String;
  lPasswordErrors: TStringList;
Begin
  DisplayUserMessage('');
  ClearPasswordValidationErrors;

  AllValid := True;

  lValid := (Dataset.FieldByName('GivenName').AsString.Trim <> '');
  AllValid := AllValid And lValid;
  TDocUtils.setControlValidity('FirstNameEdit', Valid_Check[lValid]);

  lValid := (Dataset.FieldByName('LastName').AsString.Trim <> '');
  AllValid := AllValid And lValid;
  TDocUtils.setControlValidity('LastNameEdit', Valid_Check[lValid]);

  lValid := (Dataset.FieldByName('Email').AsString.Trim <> '');
  AllValid := AllValid And lValid;
  TDocUtils.setControlValidity('EmailEdit', Valid_Check[lValid]);

  lPassword := Trim(UserPassword.Text);
  FNewUserPassword := lPassword;
  If lPassword <> '' Then
    Dataset.FieldByName('UserPassword').AsString := lPassword;

  If IsNewUser Then
  Begin
    lPasswordErrors := TStringList.Create;
    Try
      CollectPasswordValidationErrors(lPassword, lPasswordErrors);
      lValid := lPasswordErrors.Count = 0;
      AllValid := AllValid And lValid;
      If Not lValid Then
        ShowPasswordValidationErrors(lPasswordErrors);
    Finally
      lPasswordErrors.Free;
    End;
  End
  Else
    TDocUtils.setControlValidity('UserPassword', Valid_Check[True]);

  Result := AllValid;
End;


Procedure TUserEditForm.SetDataset(Const Value: TDataset);
Var
  lBranchType: string;
Begin
  FNewUserPassword := '';
  ClearPasswordValidationErrors;
  UserDataSource.Dataset := Value;
  EmailEdit.Enabled := (Not Dataset.FieldByName('EmailConfirmed').AsBoolean);
  FUser := TUserManagerUtils.DatasetToUser(Value);

  // UI label is "All"; older records may still store None/NotSpecified
  lBranchType := Trim(Dataset.FieldByName('BranchIdType').AsString);
  if (lBranchType = '') or SameText(lBranchType, 'None') or
     SameText(lBranchType, 'NotSpecified') then
    Dataset.FieldByName('BranchIdType').AsString := 'All';

  LoadLists;
  PasswordPanel.Visible := IsNewUser;
  PasswordHintLabel.Visible := IsNewUser;
  PasswordErrorLabel.Visible := False;
  if not IsNewUser then
  begin
    Dataset.FieldByName('UserPassword').AsString := '';
    UserPassword.Text := '';
    asm
      var pwd = document.getElementById('UserPassword');
      if (pwd) {
        pwd.value = '';
        pwd.setAttribute('autocomplete', 'off');
      }
    end;
  end
  else
    asm
      var pwd = document.getElementById('UserPassword');
      if (pwd) {
        pwd.setAttribute('autocomplete', 'new-password');
      }
    end;
End;

Procedure TUserEditForm.UserEditCancelButtonClick(Sender: TObject);
Begin
  ModalResult := mrCancel;
End;

Procedure TUserEditForm.SyncBranchAssignmentToDataset;
Var
  lType: TBranchIdType;
  lBranchId: String;
Begin
  lType := BranchIdType;
  lBranchId := Trim(BranchIdEdit.Value);

  Case lType Of
    TBranchIdType.NotSpecified:
      Begin
        Dataset.FieldByName('BranchIdType').AsString := 'All';
        Dataset.FieldByName('BranchId').AsString := '';
      End;
    TBranchIdType.Branch:
      Begin
        Dataset.FieldByName('BranchIdType').AsString := 'Branch';
        Dataset.FieldByName('BranchId').AsString := lBranchId;
      End;
    TBranchIdType.BranchGroup:
      Begin
        Dataset.FieldByName('BranchIdType').AsString := 'BranchGroup';
        Dataset.FieldByName('BranchId').AsString := lBranchId;
      End;
  End;
End;

Procedure TUserEditForm.UserEditSaveButtonClick(Sender: TObject);
Begin
  If Not ValidateFields Then
    Exit;

  SyncBranchAssignmentToDataset;

  If IsNewUser Then
  Begin
    If Not Await(SaveNewUser) Then
      Exit;
  End;

  ModalResult := mrOk;
End;

Procedure TUserEditForm.LoadLists;
begin
  await(LoadBranches);
  await(LoadBranchGroups);
  LoadListTimer.Enabled := true;
end;

procedure TUserEditForm.LoadBranches;
Const
  branch_svc =  'IBranchService.GetAllBranches';
Var
  lRetval: TXDataClientResponse;
  lList: TJSArray;
  I: Integer;
  lBranch: TBranch;
  lSelectedBranchId: string;
Begin
  if not Assigned(FBranches) then
  begin
     FBranches := TList<TBranch>.Create;
     lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(branch_svc, []));
     lList := TsmxXDataUtils.AsArray(lRetval);
     for I := 0 to lList.Length - 1  do
        FBranches.Add(TBranch.Create(JS.toObject(lList[I])));
  end;
End;

procedure TUserEditForm.LoadBranchGroups;
Const
  branchgroup_svc = 'IBranchService.GetSelectableBranchGroups';
Var
  lRetval: TXDataClientResponse;
  lList: TJSArray;
  I: Integer;
  lBranchGroup: TBranchGroup;
  lSelectedBranchGroupId: string;
Begin
  if not Assigned(FBranchGroups) then
  begin
     FBranchGroups := TList<TBranchGroup>.Create;
     lRetval := Await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(branchgroup_svc, []));
     lList := TsmxXDataUtils.AsArray(lRetval);
     for I := 0 to lList.Length - 1  do
        FBranchGroups.Add(TBranchGroup.Create(JS.toObject(lList[I])));
  end;
End;

procedure TUserEditForm.LoadListTimerTimer(Sender: TObject);
begin
  LoadListTimer.Enabled := false;
  LoadBranchIdLookup;
end;

procedure TUserEditForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  InternalIdLabel := TDBLabel.Create('InternalIdLabel');
  UserEditMessage := TLabel.Create('UserEditMessage');
  BranchIdLabel := TLabel.Create('BranchIdLabel');
  FirstNameEdit := TDBEdit.Create('FirstNameEdit');
  LastNameEdit := TDBEdit.Create('LastNameEdit');
  TitleEdit := TDBEdit.Create('TitleEdit');
  PhoneNumberEdit := TDBEdit.Create('PhoneNumberEdit');
  EmailEdit := TDBEdit.Create('EmailEdit');
  UserScopeEdit := TDBLookupComboBox.Create('UserScopeEdit');
  UserStatusEdit := TDBLookupComboBox.Create('UserStatusEdit');
  UserEditCancelButton := TButton.Create('UserEditCancelButton');
  UserEditSaveButton := TButton.Create('UserEditSaveButton');
  UserChange := TMessageDlg.Create(Self);
  BranchIdTypeEdit := TDBComboBox.Create('BranchIdType');
  BranchIdEdit := TDBLookupComboBox.Create('BranchIdEdit');
  PasswordPanel := TPanel.Create('PasswordPanel');
  UserPassword := TDBEdit.Create('UserPassword');
  PasswordErrorLabel := TLabel.Create('PasswordErrorLabel');
  PasswordHintLabel := TLabel.Create('PasswordHintLabel');
  UserDataSource := TDataSource.Create(Self);
  LoadListTimer := TTimer.Create(Self);

  InternalIdLabel.BeforeLoadDFMValues;
  UserEditMessage.BeforeLoadDFMValues;
  BranchIdLabel.BeforeLoadDFMValues;
  FirstNameEdit.BeforeLoadDFMValues;
  LastNameEdit.BeforeLoadDFMValues;
  TitleEdit.BeforeLoadDFMValues;
  PhoneNumberEdit.BeforeLoadDFMValues;
  EmailEdit.BeforeLoadDFMValues;
  UserScopeEdit.BeforeLoadDFMValues;
  UserStatusEdit.BeforeLoadDFMValues;
  UserEditCancelButton.BeforeLoadDFMValues;
  UserEditSaveButton.BeforeLoadDFMValues;
  UserChange.BeforeLoadDFMValues;
  BranchIdTypeEdit.BeforeLoadDFMValues;
  BranchIdEdit.BeforeLoadDFMValues;
  PasswordPanel.BeforeLoadDFMValues;
  UserPassword.BeforeLoadDFMValues;
  PasswordErrorLabel.BeforeLoadDFMValues;
  PasswordHintLabel.BeforeLoadDFMValues;
  UserDataSource.BeforeLoadDFMValues;
  LoadListTimer.BeforeLoadDFMValues;
  try
    CSSLibrary := cssBootstrap;
    ElementClassName := 'PopUpForm';
    ElementFont := efCSS;
    ElementPosition := epIgnore;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnDestroy', 'WebFormDestroy');
    InternalIdLabel.SetParentComponent(Self);
    InternalIdLabel.Name := 'InternalIdLabel';
    InternalIdLabel.Left := 48;
    InternalIdLabel.Top := 32;
    InternalIdLabel.Width := 50;
    InternalIdLabel.Height := 15;
    InternalIdLabel.Caption := 'InternalId';
    InternalIdLabel.ElementClassName := 'form-control-manual';
    InternalIdLabel.ElementPosition := epIgnore;
    InternalIdLabel.HeightStyle := ssAuto;
    InternalIdLabel.HeightPercent := 100.000000000000000000;
    InternalIdLabel.HTMLType := tSPAN;
    InternalIdLabel.WidthStyle := ssAuto;
    InternalIdLabel.WidthPercent := 100.000000000000000000;
    InternalIdLabel.DataField := 'InternalId';
    InternalIdLabel.DataSource := UserDataSource;
    UserEditMessage.SetParentComponent(Self);
    UserEditMessage.Name := 'UserEditMessage';
    UserEditMessage.Left := 288;
    UserEditMessage.Top := 232;
    UserEditMessage.Width := 89;
    UserEditMessage.Height := 15;
    UserEditMessage.Caption := 'UserEditMessage';
    UserEditMessage.ElementClassName := 'UserEditMessage';
    UserEditMessage.ElementFont := efCSS;
    UserEditMessage.ElementPosition := epIgnore;
    UserEditMessage.HeightStyle := ssAuto;
    UserEditMessage.HeightPercent := 100.000000000000000000;
    UserEditMessage.HTMLType := tSPAN;
    UserEditMessage.Visible := False;
    UserEditMessage.WidthStyle := ssAuto;
    UserEditMessage.WidthPercent := 100.000000000000000000;
    BranchIdLabel.SetParentComponent(Self);
    BranchIdLabel.Name := 'BranchIdLabel';
    BranchIdLabel.Left := 48;
    BranchIdLabel.Top := 328;
    BranchIdLabel.Width := 115;
    BranchIdLabel.Height := 15;
    BranchIdLabel.Caption := 'Branch Group/Branch';
    BranchIdLabel.ElementFont := efCSS;
    BranchIdLabel.HeightStyle := ssAuto;
    BranchIdLabel.HeightPercent := 100.000000000000000000;
    BranchIdLabel.WidthPercent := 100.000000000000000000;
    FirstNameEdit.SetParentComponent(Self);
    FirstNameEdit.Name := 'FirstNameEdit';
    FirstNameEdit.Left := 48;
    FirstNameEdit.Top := 80;
    FirstNameEdit.Width := 121;
    FirstNameEdit.Height := 22;
    FirstNameEdit.ChildOrder := 1;
    FirstNameEdit.ElementClassName := 'form-control';
    FirstNameEdit.ElementFont := efCSS;
    FirstNameEdit.ElementPosition := epIgnore;
    FirstNameEdit.HeightStyle := ssAuto;
    FirstNameEdit.HeightPercent := 100.000000000000000000;
    FirstNameEdit.Text := 'FirstNameEdit';
    FirstNameEdit.WidthStyle := ssAuto;
    FirstNameEdit.WidthPercent := 100.000000000000000000;
    FirstNameEdit.DataField := 'GivenName';
    FirstNameEdit.DataSource := UserDataSource;
    LastNameEdit.SetParentComponent(Self);
    LastNameEdit.Name := 'LastNameEdit';
    LastNameEdit.Left := 48;
    LastNameEdit.Top := 108;
    LastNameEdit.Width := 121;
    LastNameEdit.Height := 22;
    LastNameEdit.ChildOrder := 1;
    LastNameEdit.ElementClassName := 'form-control';
    LastNameEdit.ElementFont := efCSS;
    LastNameEdit.ElementPosition := epIgnore;
    LastNameEdit.HeightStyle := ssAuto;
    LastNameEdit.HeightPercent := 100.000000000000000000;
    LastNameEdit.Text := 'LastNameEdit';
    LastNameEdit.WidthStyle := ssAuto;
    LastNameEdit.WidthPercent := 100.000000000000000000;
    LastNameEdit.DataField := 'LastName';
    LastNameEdit.DataSource := UserDataSource;
    TitleEdit.SetParentComponent(Self);
    TitleEdit.Name := 'TitleEdit';
    TitleEdit.Left := 48;
    TitleEdit.Top := 53;
    TitleEdit.Width := 121;
    TitleEdit.Height := 22;
    TitleEdit.ChildOrder := 1;
    TitleEdit.ElementClassName := 'form-control';
    TitleEdit.ElementFont := efCSS;
    TitleEdit.ElementPosition := epIgnore;
    TitleEdit.HeightStyle := ssAuto;
    TitleEdit.HeightPercent := 100.000000000000000000;
    TitleEdit.Text := 'TitleEdit';
    TitleEdit.WidthStyle := ssAuto;
    TitleEdit.WidthPercent := 100.000000000000000000;
    TitleEdit.DataField := 'Title';
    TitleEdit.DataSource := UserDataSource;
    PhoneNumberEdit.SetParentComponent(Self);
    PhoneNumberEdit.Name := 'PhoneNumberEdit';
    PhoneNumberEdit.Left := 48;
    PhoneNumberEdit.Top := 164;
    PhoneNumberEdit.Width := 121;
    PhoneNumberEdit.Height := 22;
    PhoneNumberEdit.ChildOrder := 1;
    PhoneNumberEdit.ElementClassName := 'form-control';
    PhoneNumberEdit.ElementFont := efCSS;
    PhoneNumberEdit.ElementPosition := epIgnore;
    PhoneNumberEdit.HeightStyle := ssAuto;
    PhoneNumberEdit.HeightPercent := 100.000000000000000000;
    PhoneNumberEdit.Text := 'PhoneNumberEdit';
    PhoneNumberEdit.WidthStyle := ssAuto;
    PhoneNumberEdit.WidthPercent := 100.000000000000000000;
    PhoneNumberEdit.DataField := 'PhoneNumber';
    PhoneNumberEdit.DataSource := UserDataSource;
    EmailEdit.SetParentComponent(Self);
    EmailEdit.Name := 'EmailEdit';
    EmailEdit.Left := 48;
    EmailEdit.Top := 136;
    EmailEdit.Width := 121;
    EmailEdit.Height := 22;
    EmailEdit.ChildOrder := 1;
    EmailEdit.ElementClassName := 'form-control';
    EmailEdit.ElementFont := efCSS;
    EmailEdit.ElementPosition := epIgnore;
    EmailEdit.HeightStyle := ssAuto;
    EmailEdit.HeightPercent := 100.000000000000000000;
    EmailEdit.Text := 'EmailEdit';
    EmailEdit.WidthStyle := ssAuto;
    EmailEdit.WidthPercent := 100.000000000000000000;
    EmailEdit.DataField := 'Email';
    EmailEdit.DataSource := UserDataSource;
    UserScopeEdit.SetParentComponent(Self);
    UserScopeEdit.Name := 'UserScopeEdit';
    UserScopeEdit.Left := 48;
    UserScopeEdit.Top := 196;
    UserScopeEdit.Width := 145;
    UserScopeEdit.Height := 22;
    UserScopeEdit.ElementClassName := 'form-select form-control';
    UserScopeEdit.ElementFont := efCSS;
    UserScopeEdit.ElementPosition := epIgnore;
    UserScopeEdit.HeightStyle := ssAuto;
    UserScopeEdit.HeightPercent := 100.000000000000000000;
    UserScopeEdit.WidthStyle := ssAuto;
    UserScopeEdit.WidthPercent := 100.000000000000000000;
    UserScopeEdit.DataField := 'UserScope';
    UserScopeEdit.DataSource := UserDataSource;
    UserScopeEdit.ListSource := MainData.DummySource;
    UserStatusEdit.SetParentComponent(Self);
    UserStatusEdit.Name := 'UserStatusEdit';
    UserStatusEdit.Left := 48;
    UserStatusEdit.Top := 224;
    UserStatusEdit.Width := 145;
    UserStatusEdit.Height := 22;
    UserStatusEdit.ElementClassName := 'form-select form-control';
    UserStatusEdit.ElementFont := efCSS;
    UserStatusEdit.ElementPosition := epIgnore;
    UserStatusEdit.HeightStyle := ssAuto;
    UserStatusEdit.HeightPercent := 100.000000000000000000;
    UserStatusEdit.WidthStyle := ssAuto;
    UserStatusEdit.WidthPercent := 100.000000000000000000;
    UserStatusEdit.DataField := 'UserStatus';
    UserStatusEdit.DataSource := UserDataSource;
    UserStatusEdit.ListSource := MainData.DummySource;
    UserEditCancelButton.SetParentComponent(Self);
    UserEditCancelButton.Name := 'UserEditCancelButton';
    UserEditCancelButton.Left := 48;
    UserEditCancelButton.Top := 424;
    UserEditCancelButton.Width := 96;
    UserEditCancelButton.Height := 25;
    UserEditCancelButton.Caption := 'Cancel';
    UserEditCancelButton.ChildOrder := 12;
    UserEditCancelButton.ElementClassName := 'btn btn-primary';
    UserEditCancelButton.ElementFont := efCSS;
    UserEditCancelButton.ElementPosition := epIgnore;
    UserEditCancelButton.HeightStyle := ssAuto;
    UserEditCancelButton.HeightPercent := 100.000000000000000000;
    UserEditCancelButton.WidthStyle := ssAuto;
    UserEditCancelButton.WidthPercent := 100.000000000000000000;
    SetEvent(UserEditCancelButton, Self, 'OnClick', 'UserEditCancelButtonClick');
    UserEditSaveButton.SetParentComponent(Self);
    UserEditSaveButton.Name := 'UserEditSaveButton';
    UserEditSaveButton.Left := 150;
    UserEditSaveButton.Top := 424;
    UserEditSaveButton.Width := 96;
    UserEditSaveButton.Height := 25;
    UserEditSaveButton.Caption := 'Save';
    UserEditSaveButton.ChildOrder := 12;
    UserEditSaveButton.ElementClassName := 'btn btn-secondary';
    UserEditSaveButton.ElementFont := efCSS;
    UserEditSaveButton.ElementPosition := epIgnore;
    UserEditSaveButton.HeightStyle := ssAuto;
    UserEditSaveButton.HeightPercent := 100.000000000000000000;
    UserEditSaveButton.WidthStyle := ssAuto;
    UserEditSaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(UserEditSaveButton, Self, 'OnClick', 'UserEditSaveButtonClick');
    UserChange.SetParentComponent(Self);
    UserChange.Name := 'UserChange';
    UserChange.Left := 584;
    UserChange.Top := 136;
    UserChange.Width := 24;
    UserChange.Height := 24;
    UserChange.HeightStyle := ssAuto;
    UserChange.WidthStyle := ssAuto;
    UserChange.Buttons := [];
    UserChange.Opacity := 0.200000000000000000;
    UserChange.ElementButtonClassName := 'btn';
    UserChange.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    UserChange.ElementTitleClassName := 'text-body';
    UserChange.ElementContentClassName := 'text-body';
    BranchIdTypeEdit.SetParentComponent(Self);
    BranchIdTypeEdit.Name := 'BranchIdTypeEdit';
    BranchIdTypeEdit.Left := 48;
    BranchIdTypeEdit.Top := 256;
    BranchIdTypeEdit.Width := 145;
    BranchIdTypeEdit.Height := 23;
    BranchIdTypeEdit.ElementClassName := 'form-select';
    BranchIdTypeEdit.ElementFont := efCSS;
    BranchIdTypeEdit.HeightStyle := ssAuto;
    BranchIdTypeEdit.HeightPercent := 100.000000000000000000;
    BranchIdTypeEdit.Text := 'BranchIdTypeEdit';
    BranchIdTypeEdit.WidthPercent := 100.000000000000000000;
    SetEvent(BranchIdTypeEdit, Self, 'OnChange', 'BranchIdTypeEditChange');
    BranchIdTypeEdit.ItemIndex := -1;
    BranchIdTypeEdit.DataField := 'BranchIdType';
    BranchIdTypeEdit.DataSource := UserDataSource;
    BranchIdEdit.SetParentComponent(Self);
    BranchIdEdit.Name := 'BranchIdEdit';
    BranchIdEdit.Left := 48;
    BranchIdEdit.Top := 349;
    BranchIdEdit.Width := 145;
    BranchIdEdit.Height := 22;
    BranchIdEdit.ElementClassName := 'form-select form-control';
    BranchIdEdit.ElementFont := efCSS;
    BranchIdEdit.ElementPosition := epIgnore;
    BranchIdEdit.HeightStyle := ssAuto;
    BranchIdEdit.HeightPercent := 100.000000000000000000;
    BranchIdEdit.WidthStyle := ssAuto;
    BranchIdEdit.WidthPercent := 100.000000000000000000;
    BranchIdEdit.DataField := 'BranchId';
    BranchIdEdit.DataSource := UserDataSource;
    BranchIdEdit.ListSource := MainData.DummySource;
    PasswordPanel.SetParentComponent(Self);
    PasswordPanel.Name := 'PasswordPanel';
    PasswordPanel.Left := 272;
    PasswordPanel.Top := 320;
    PasswordPanel.Width := 225;
    PasswordPanel.Height := 60;
    PasswordPanel.ElementClassName := 'row w-100';
    PasswordPanel.HeightStyle := ssAuto;
    PasswordPanel.WidthStyle := ssAuto;
    PasswordPanel.WidthPercent := 100.000000000000000000;
    PasswordPanel.BorderColor := clNone;
    PasswordPanel.BorderStyle := bsNone;
    PasswordPanel.ChildOrder := 15;
    PasswordPanel.Color := clWhite;
    PasswordPanel.ElementFont := efCSS;
    PasswordPanel.ElementPosition := epIgnore;
    PasswordPanel.TabOrder := 12;
    PasswordPanel.Visible := False;
    UserPassword.SetParentComponent(PasswordPanel);
    UserPassword.Name := 'UserPassword';
    UserPassword.Left := 16;
    UserPassword.Top := 16;
    UserPassword.Width := 121;
    UserPassword.Height := 22;
    UserPassword.ElementClassName := 'form-control';
    UserPassword.ElementFont := efCSS;
    UserPassword.ElementPosition := epIgnore;
    UserPassword.HeightStyle := ssAuto;
    UserPassword.HeightPercent := 100.000000000000000000;
    UserPassword.Text := 'UserPassword';
    UserPassword.WidthStyle := ssAuto;
    UserPassword.WidthPercent := 100.000000000000000000;
    UserPassword.DataField := 'UserPassword';
    UserPassword.DataSource := UserDataSource;
    PasswordErrorLabel.SetParentComponent(PasswordPanel);
    PasswordErrorLabel.Name := 'PasswordErrorLabel';
    PasswordErrorLabel.Left := 16;
    PasswordErrorLabel.Top := 44;
    PasswordErrorLabel.Width := 193;
    PasswordErrorLabel.Height := 15;
    PasswordErrorLabel.ElementClassName := 'alert alert-danger mt-2 mb-0 py-2 px-3';
    PasswordErrorLabel.ElementFont := efCSS;
    PasswordErrorLabel.ElementPosition := epIgnore;
    PasswordErrorLabel.HeightStyle := ssAuto;
    PasswordErrorLabel.HeightPercent := 100.000000000000000000;
    PasswordErrorLabel.HTMLType := tDIV;
    PasswordErrorLabel.Visible := False;
    PasswordErrorLabel.WidthStyle := ssAuto;
    PasswordErrorLabel.WidthPercent := 100.000000000000000000;
    PasswordHintLabel.SetParentComponent(PasswordPanel);
    PasswordHintLabel.Name := 'PasswordHintLabel';
    PasswordHintLabel.Left := 16;
    PasswordHintLabel.Top := 72;
    PasswordHintLabel.Width := 193;
    PasswordHintLabel.Height := 15;
    PasswordHintLabel.Caption := 'Passwords must be at least 10 characters and include an uppercase letter, a lowercase letter, a digit, and a symbol.';
    PasswordHintLabel.ElementClassName := 'form-text text-muted';
    PasswordHintLabel.ElementFont := efCSS;
    PasswordHintLabel.ElementPosition := epIgnore;
    PasswordHintLabel.HeightStyle := ssAuto;
    PasswordHintLabel.HeightPercent := 100.000000000000000000;
    PasswordHintLabel.HTMLType := tDIV;
    PasswordHintLabel.WidthStyle := ssAuto;
    PasswordHintLabel.WidthPercent := 100.000000000000000000;
    UserDataSource.SetParentComponent(Self);
    UserDataSource.Name := 'UserDataSource';
    UserDataSource.Left := 440;
    UserDataSource.Top := 40;
    LoadListTimer.SetParentComponent(Self);
    LoadListTimer.Name := 'LoadListTimer';
    LoadListTimer.Enabled := False;
    SetEvent(LoadListTimer, Self, 'OnTimer', 'LoadListTimerTimer');
    LoadListTimer.Left := 464;
    LoadListTimer.Top := 392;
  finally
    InternalIdLabel.AfterLoadDFMValues;
    UserEditMessage.AfterLoadDFMValues;
    BranchIdLabel.AfterLoadDFMValues;
    FirstNameEdit.AfterLoadDFMValues;
    LastNameEdit.AfterLoadDFMValues;
    TitleEdit.AfterLoadDFMValues;
    PhoneNumberEdit.AfterLoadDFMValues;
    EmailEdit.AfterLoadDFMValues;
    UserScopeEdit.AfterLoadDFMValues;
    UserStatusEdit.AfterLoadDFMValues;
    UserEditCancelButton.AfterLoadDFMValues;
    UserEditSaveButton.AfterLoadDFMValues;
    UserChange.AfterLoadDFMValues;
    BranchIdTypeEdit.AfterLoadDFMValues;
    BranchIdEdit.AfterLoadDFMValues;
    PasswordPanel.AfterLoadDFMValues;
    UserPassword.AfterLoadDFMValues;
    PasswordErrorLabel.AfterLoadDFMValues;
    PasswordHintLabel.AfterLoadDFMValues;
    UserDataSource.AfterLoadDFMValues;
    LoadListTimer.AfterLoadDFMValues;
  end;
end;

End.
